import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { money, fmtViews } from "@/lib/format";
import { toast } from "sonner";

export default function SubmitClip({ open, onClose, campaignId, campaigns }) {
  const [cid, setCid] = useState(campaignId || "");
  const [url, setUrl] = useState("");
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { setCid(campaignId || ""); }, [campaignId, open]);
  useEffect(() => { if (!open) { setUrl(""); setPreview(null); } }, [open]);

  const doPreview = async () => {
    if (!url) return;
    setLoading(true);
    try { const { data } = await api.post("/submissions/preview", { url, campaign_id: cid }); setPreview(data); }
    catch (e) { toast.error(apiError(e)); setPreview(null); }
    setLoading(false);
  };
  const submit = async () => {
    setLoading(true);
    try { await api.post("/submissions", { campaign_id: cid, url }); toast.success("Clip submitted for review"); onClose(); }
    catch (e) { toast.error(apiError(e)); }
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent style={{ background: "var(--surface)", border: "1px solid var(--border-strong)", color: "var(--text)", borderRadius: 20 }} data-testid="submit-clip-dialog">
        <DialogHeader><DialogTitle style={{ fontWeight: 500 }}>Submit a clip</DialogTitle></DialogHeader>
        {campaigns && (
          <select className="input-dark" value={cid} onChange={(e) => setCid(e.target.value)} data-testid="submit-campaign-select">
            <option value="">Select campaign</option>
            {campaigns.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}
          </select>
        )}
        <input className="input-dark" placeholder="Paste your clip link (YouTube, TikTok, Reels, X)" value={url} onChange={(e) => setUrl(e.target.value)} onBlur={doPreview} data-testid="submit-url-input" />
        {loading && <div style={{ color: "var(--muted)", fontSize: 13 }}>Checking…</div>}
        {preview && !preview.fetch_error && (
          <div className="raised" style={{ borderRadius: 12, padding: 12 }}>
            <div style={{ fontSize: 12, color: "var(--muted)", textTransform: "capitalize" }}>{preview.platform}</div>
            <div style={{ fontWeight: 500, margin: "4px 0" }}>{preview.title || "Clip detected"}</div>
            {preview.views != null && <div style={{ fontSize: 13, color: "var(--sub)" }}>{fmtViews(preview.views)} views</div>}
          </div>
        )}
        {preview?.fetch_error && <div style={{ fontSize: 12, color: "var(--warning)" }}>Preview unavailable, you can still submit.</div>}
        <button className="btn-brand focus-ring" onClick={submit} disabled={loading || !url || !cid} data-testid="submit-confirm" style={{ padding: "10px 16px" }}>Submit for review</button>
      </DialogContent>
    </Dialog>
  );
}
